import { useEffect, useState } from "react";
import client from "../client/Client";
import { Button, Dialog, DialogBody, DialogFooter, DialogHeader } from "@material-tailwind/react";

interface OrganizersContent {
  Date: string;
  Information: string;
  Title: string;
  ReadMore: Array<{
    children: Array<{ text: string }>;
  }>;
}

export default function Testimonials() {
  const [open, setOpen] = useState(false);
  const [moreDetails, setMoreDetails] = useState<OrganizersContent>({
    Date: "",
    Information: "",
    Title: "",
    ReadMore: []
  });
  const [data, setData] = useState<OrganizersContent[]>([]);

  useEffect(() => {
    client
      .fetch('*[_type == "RecentNews"]')
      .then((result) => {
        setData(result[0].RecentNews);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleClick = (item: OrganizersContent) => {
    setMoreDetails(item);
    handleOpen();
  };

  return (
    <section className="w-full px-4 sm:px-6 py-8">
      <div className="space-y-4">
        {data && data.map((item, index) => (
          <div 
            key={index}
            className="bg-red-50 border-l-4 border-red-500 p-5 rounded-r-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer hover:bg-red-100"
            onClick={() => handleClick(item)}
          >
            <div className="flex items-center justify-between">
              <div className="flex-1 min-w-0 text-left">
                <h3 className="text-xl font-bold text-red-700 mb-2">
                  {item?.Title}
                </h3>
                <p className="text-base text-gray-700 line-clamp-2">
                  {item?.Information}
                </p>
              </div>
              <div className="ml-6 flex-shrink-0 flex flex-col items-end space-y-3">
                <span className="text-sm font-semibold text-red-600 bg-white   px-3 py-2 rounded-full shadow-sm">
                  {item?.Date}
                </span>
                <button 
                  onClick={(e) => {
                    console.log(data);
                    e.stopPropagation();
                    handleClick(item);
                  }}
                  className="text-sm bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
                >
                  Read More
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* More Rounded Modal */}
      
      <Dialog 
        handler={handleOpen} 
        open={open} 
        size="xl"
        className="rounded-2xl overflow-hidden" // Added rounded-2xl for more rounding
      >
        <DialogHeader className="p-6 border-b border-red-200 bg-red-50 text-left rounded-t-2xl"> {/* Rounded top corners */}
          <div className="w-full">
            <h1 className="text-2xl font-bold text-red-700 mb-2">
              {moreDetails?.Title}
            </h1>
            <p className="text-lg text-red-600 font-semibold">
              {moreDetails?.Date}
            </p>
          </div>
        </DialogHeader>
        
        <DialogBody className="p-6 max-h-96 overflow-y-auto text-left">
          {moreDetails?.ReadMore?.length > 0 ? (
            <div className="space-y-4">
              {moreDetails?.ReadMore && moreDetails.ReadMore.length > 0 &&
                moreDetails.ReadMore.map((block: any, i: number) => (
                  <div key={block._key || i}>
                    <p className="text-lg text-gray-800 leading-relaxed mb-3">
                      {block.children.map((child: any, childIdx: number) => {
                        // Find link data if any marks reference it
                        const linkData =
                          child.marks && child.marks.length > 0
                            ? block.markDefs?.find(
                                (def: any) => def._key === child.marks[0]
                              )
                            : null;

                        // Detect text formatting marks
                        const hasStrong = child.marks?.includes("strong");
                        const hasUnderline = child.marks?.includes("underline");

                        // Determine CSS classes based on marks
                        let textClasses = "";
                        if (hasStrong && hasUnderline) {
                          textClasses = "font-bold text-red-600"; // bold + red (no underline)
                        } else if (hasStrong) {
                          textClasses = "font-bold"; // bold
                        } else if (hasUnderline) {
                          textClasses = "underline"; // underline
                        }

                        // Styled span for text
                        const content = (
                          <span key={childIdx} className={textClasses}>
                            {child.text}
                          </span>
                        );

                        // Wrap with <a> if linkData exists
                        if (linkData) {
                          return (
                            <a
                              key={childIdx}
                              href={linkData.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-901 hover:text-blue-800 font-medium underline transition-colors duration-200"
                            >
                              {content}
                            </a>
                          );
                        }

                        // Otherwise return styled span
                        return content;
                      })}
                    </p>
                  </div>
                ))}
            </div>

          ) : (
            <p className="text-gray-600 text-lg py-6 text-center">No additional content available.</p>
          )}
        </DialogBody>
        
        <DialogFooter className="p-6 border-t border-red-200 bg-red-50 rounded-b-2xl"> 
          <Button 
            className="bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200 text-base shadow-md" // Changed to rounded-xl for button
            onClick={handleOpen}
          >
            Close
          </Button>
        </DialogFooter>
      </Dialog>
    </section>
  );
}